<a (click)="onclick()">
  <!-- desktop -->
  <div class="d-none d-lg-flex logo-desktop w-100">
    <img class="d-md-inline-block img-fluid" src="assets/image/Hogia-logo-small.png" />
    <div class="d-md-inline-block logo-text">
      <span>DinHyresvärd</span>
    </div>
  </div>

  <!-- mobile -->
  <div class="d-inline-block d-lg-none logo-mobile">
    <span>DH</span>
  </div>
</a>
